/*
 * @Author: mayanxia 
 * @Date: 2020-11-07 19:54:20 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-29 16:57:15
 */

<template xmlns:background-color="http://www.w3.org/1999/xhtml">
  <a-row :gutter="10">
    <a-col :md="12" :sm="24">
      <a-card :bordered="false">

        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <!--2020-11-16注释掉添加第一级区域的功能，添加部门的时候会判断，如果添加的是公司则会默认的在区域中添加一条数据，父区域为公司的主键id-->
          <!--<a-button @click="handleAdd(1)" type="primary">添加区域</a-button>-->
          <a-button @click="handleAdd(2)" type="primary" v-has="'area:add'">{{ $t('添加下级') }}</a-button>
          <!--
          <a-button type="primary" icon="download" @click="handleExportXls('部门信息')">导出</a-button>
          <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload>
          <a-button title="删除多条数据" @click="batchDel" type="default">批量删除</a-button>
          -->
          <!--<a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>-->
        </a-row>
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" :placeholder="$t('请输入区域名称')" @search="onSearchArea" />
          <!-- 树-->
          <a-col :md="24" :sm="24" style="max-height: 60vh;overflow: auto">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <a-dropdown :trigger="[dropTrigger]"  @visibleChange="dropStatus">
                  <span style="user-select: none">
                    <a-tree
                      @select="onSelect"
                      @check="onCheck"
                      @rightClick="rightHandle"
                      :selectedKeys="selectedKeys"
                      :checkedKeys="checkedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand"/>
                  </span>
                  -->
                  <!--新增右键点击事件,和增加添加和删除功能-->
                  <!--
                  <a-menu slot="overlay">
                    <a-menu-item @click="handleAdd(3)" key="1" v-has="'area:add'">添加</a-menu-item>
                    <a-menu-item @click="handleDelete" key="2" v-has="'area:delete'">删除</a-menu-item>
                    <a-menu-item @click="closeDrop" key="3">取消</a-menu-item>
                  </a-menu>
                </a-dropdown>
                -->
                <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    :default-expand-all="false"
                    @node-click="nodeClick"
                    @node-contextmenu="nodeContextmenu"
                    ref="areaTree">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span class="tree-node-title">{{ node.label }}</span>
                      <span>
                        <a-button
                          v-has="'area:add'"
                          type="link"
                          size="small"
                          @click="() => handleAdd(3,data)">
                          {{ $t('添加') }}
                        </a-button>
                        <!--增加判断如果区域是总区域则不允许删除-->
                        <a-button
                          v-has="'area:delete'"
                          :disabled="data.areaParentId==null||data.areaParentId==''"
                          type="link"
                          size="small"
                          @click="() => handleDelete(node, data)">
                          {{ $t('删除') }}
                        </a-button>
                      </span>
                    </span>
                  </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <!--
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>
            <a-menu-item key="3" @click="checkALL">全部勾选</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">取消全选</a-menu-item>
            <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
            <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
          </a-menu>
          <a-button>
            树操作 <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
      -->
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="12" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('基本信息')" key="1" >
          <a-card :bordered="false" v-if="currentNodeKey!=null">
            
            <a-form :form="form">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('区域ID')">
                <a-input placeholder="" v-decorator="['id' ]" disabled style="width: 80%" />
                <a-button @click="copy" type="primary" class="copy_btn" :data-clipboard-text="form.getFieldValue('id')">{{ $t('复制') }}</a-button>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('上级区域')">
                <a-tree-select
                  style="width:100%"
                  :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                  :treeData="treeData"
                  :disabled="disable"
                  v-model="model.areaParentId"
                  :placeholder="$t('无')">
                </a-tree-select>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('区域名称')">
                <a-input :placeholder="$t('请输入区域/小区名称')" v-decorator="['areaName', validatorRules.areaName ]"/>
              </a-form-item>
              <!--
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="区域编码">
                <a-input placeholder="请输入区域编码" v-decorator="['areaId', validatorRules.areaId ]"/>
              </a-form-item>
              -->
              <!--
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="排序">
                <a-input-number v-decorator="[ 'departOrder',{'initialValue':0}]"/>
              </a-form-item>
              -->
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('负责人')">
                <a-input :placeholder="$t('请输入负责人名称')" v-decorator="['areaManager', {'initialValue':''}]"/>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('手机号')">
                <a-input :placeholder="$t('请输入负责人手机号')" v-decorator="['areaTel', {'initialValue':''}]"/>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('备注')">
                <a-textarea :placeholder="$t('请输入备注')" v-decorator="['areaRemark', {'initialValue':''}]"/>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t('创建时间')">
                <a-input :placeholder="$t('请输入创建时间')" :disabled="disable" v-decorator="['createTime', {'initialValue':''}]"/>
              </a-form-item>
            </a-form>
            <div class="anty-form-btn">
              <a-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync" v-has="'area:edit'">{{ $t('重置') }}</a-button>
              <a-button @click="submitCurrForm" type="primary" htmlType="button" icon="form" v-has="'area:edit'">{{ $t('保存') }}</a-button>
            </div>
          </a-card>
          <a-card v-else >
            <a-empty>
              <span slot="description"> {{ $t('请先选择一个区域!') }} </span>
            </a-empty>
          </a-card>
        </a-tab-pane>
      </a-tabs>

    </a-col>
    <meter-area-modal ref="modalForm" @ok="modalFormOk"></meter-area-modal>
  </a-row>
</template>
<script>
  import pick from 'lodash.pick'
  import {queryAreaTreeList, searchAreaByKeywords, deleteByAreaId} from '@/api/api'
  import {httpAction, deleteAction,getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterAreaModal from './modules/MeterAreaModal'
  import Clipboard from 'clipboard'

  export default {
    name: 'meterAreaList',
    mixins: [JeecgListMixin,AreaChoosetMixin],
    components: {
      MeterAreaModal
    },
    data() {
      return {
        disableMixinCreated: true,
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        disable: true,
        treeData: [],
        visible: false,
        areaTree: [],
        rightClickSelectedKey: '',
        rightClickSelectedOrgCode: '',
        hiding: true,
        model: {},
        dropTrigger: '',
        checkedKeys: [],
        selectedKeys: [],
        currSelected: {},

        allTreeKeys:[],
        checkStrictly: true,

        form: this.$form.createForm(this),
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        url: {
          edit: "/jeecg-charge/meter/meterArea/edit",
          deleteBatch: "/jeecg-charge/meter/meterArea/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterArea/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterArea/importExcel",
          searchByKeywords: "/jeecg-charge/meter/meterArea/queryByKeyWord"
        },
        areaLoading: false,
        defaultProps: {
          children: 'children',
          label: 'areaName'
        },
        currentNodeKey: null,
        searchAreaValue: '',
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules() {
        return {
          areaName: {rules: [{required: true, message: this.$t('请输入区域/小区名称!')}]},
          //areaId: {rules: [{required: true, message: this.$t('请输入区域编码!')}]},
          areaManager: {rules: [{required: true, message: this.$t('请输入负责人!')}]},
          areaTel: {rules: [{validator: this.validateMobile}]}
        }
      }
    },
    methods: {
      loadTree() {
        this.areaLoading = true
        var that = this
        that.treeData = []
        that.areaTree = []
        queryAreaTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.areaTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
              // console.log(temp.id)
            }
            
          }
        }).finally(()=> {
          this.areaLoading = false
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          // for (let a = 0; a < node.children.length; a++) {
          //   this.setThisExpandedKeys(node.children[a])
          // }
        }
      },
      // 右键操作方法
      rightHandle(node) {
        this.dropTrigger = 'contextmenu'
        console.log(node.node.eventKey)
        this.rightClickSelectedKey = node.node.eventKey
        //this.rightClickSelectedAreaId = node.node.dataRef.areaId
        console.log( node.node.dataRef)
      },
      // 右键操作方法
      nodeContextmenu(e,record,node,element) {
        this.dropTrigger = 'contextmenu'
        this.rightClickSelectedKey = node.data.key
        console.log(this.rightClickSelectedKey)
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      // 右键点击下拉框改变事件
      dropStatus(visible) {
        if (visible == false) {
          this.dropTrigger = ''
        }
      },
      // 右键店家下拉关闭下拉框
      closeDrop() {
        this.dropTrigger = ''
      },
      onSearch(value) {
        let that = this
        if (value) {
          searchAreaByKeywords({keyWord: value}).then((res) => {
            if (res.success&&res.result!==null) {
              that.areaTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.areaTree.push(temp)
              }
            }else if(res.result===null){
              that.areaTree = []
              that.$message.warning(that.$t("未查询到数据！"))
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      onCheck(checkedKeys, info) {
        console.log('onCheck', checkedKeys, info)
        this.hiding = false
        //this.checkedKeys = checkedKeys.checked
        // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
        if(this.checkStrictly){
          this.checkedKeys = checkedKeys.checked;
        }else{
          this.checkedKeys = checkedKeys
        }
        // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      },
      onSelect(selectedKeys, e) {
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        console.log('onSelect-record', record)
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        this.selectedKeys = [record.key]
        this.model.areaParentId = record.areaParentId
        this.setValuesToForm(record)

      },
      // 触发onSelect事件时,为部门树右侧的form表单赋值
      setValuesToForm(record) {
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(record, 'id','areaName','areaParentId', 'areaManager', 'areaTel','areaRemark','createTime'))
        })
      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.form.resetFields()
        this.selectedKeys = []
        this.currentNodeKey = null
        this.$refs.areaTree.setCheckedKeys([])
      },
      submitCurrForm() {
        this.form.validateFields((err, values) => {
          if (!err) {
            if (!this.currSelected.id) {
              this.$message.warning(this.$t('请点击选择要修改区域!'))
              return
            }
            let formData = Object.assign(this.currSelected, values)
            delete formData.createTime;
            delete formData.updateTime;
            console.log('Received values of form: ', formData)
            httpAction(this.url.edit, formData, 'put').then((res) => {
              if (res.success) {
                this.$message.success(this.$t('保存成功!'))
                this.loadTree()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      emptyCurrForm() {
        this.setValuesToForm(this.model)
      },
      handleAdd(num,data) {
        console.log(num)
        if (num == 1) {
          this.$refs.modalForm.add()
          this.$refs.modalForm.title = this.$t('新增')
        } else if (num == 2) {
          let key = this.currSelected.key
          if (!key) {
            this.$message.warning(this.$t('请先点击选中上级区域！'))
            return false
          }
          this.$refs.modalForm.add(key)
          this.$refs.modalForm.title = this.$t('新增')
        } else {
          this.$refs.modalForm.add(data.id)
          this.$refs.modalForm.title = this.$t('新增')
        }
      },
      handleDelete(node,data) {
          console.log(data)
        var that = this
        this.$confirm({
          title: this.$t('确认删除'),
          content: this.$t('确定要删除此区域{name}以及子节点数据吗?', { name: data.areaName }),
          onOk: function () {
            deleteByAreaId({id: data.id}).then((resp) => {
              if (resp.success) {
                console.log("删除成功")
                //删除成功后，去除已选中中的数据
                if(that.currentNodeKey === data.id) {
                    that.currentNodeKey = null
                }
                that.$message.success(that.$t('删除成功!'))
                that.loadTree()
                //删除后同步清空右侧基本信息内容
                that.onClearSelected()
              } else {
                that.$message.error(resp.message)
              }
            })
          }
        })
      },
     // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      checkALL () {
        this.checkStriccheckStrictlytly = false
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if(v==1){
          this.checkStrictly = false
        }else if(v==2){
          this.checkStrictly = true
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      copy() {
        let clipboard = new Clipboard('.copy_btn')
        clipboard.on('success', (e) => {
          this.$message.success(this.$t('复制成功'))
          clipboard.destroy() // 释放内存
        })
        clipboard.on('error', (e) => {
          this.$message.error(this.$t('不支持复制'))
          clipboard.destroy() // 释放内存
        })
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.loadTree()
      },
      // 以下是20220228组件改为elementui中tree组件后做的相应的配置
      nodeClick(record,node,data) {
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
        if(node.checked) {
          this.currentNodeKey = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          //this.$refs.areaTree.setCurrentKey(record.id)
          this.currSelected = Object.assign({}, record);
          this.model.areaParentId = record.areaParentId
          this.setValuesToForm(record)
        }else{
          this.currentNodeKey = null
          this.currSelected = {};
        }
      },
    },
    created() {
      this.loadTree()
    },

  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
    .filter-tree.el-tree--highlight-current /deep/ .el-tree-node.is-checked>.el-tree-node__content{
    background: none;
  }
  .filter-tree.el-tree--highlight-current .el-tree-node>.el-tree-node__content .custom-tree-node .tree-node-title{
    padding: 0 5px;
  }
   .filter-tree.el-tree--highlight-current .el-tree-node.is-checked>.el-tree-node__content .custom-tree-node .tree-node-title{
    background-color: #bae7ff;
    padding: 0 5px;
  }
  .filter-tree.el-tree--highlight-current /deep/ .el-tree-node.is-current>.el-tree-node__content {
    background-color: none!important;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>